module.exports = __webpack_public_path__ + "img/folder.6bfe717.png";